import CustomNavbar from '../components/Navbar';
import Footer from '../components/Footer';
import FullScreenCarousel from '../components/carousel';
import HomeCards from '../components/HomeCards';

function HomePage() {

    const slides = [
        {
            image: "/images/chocolate.jpg",
            title: "Eastern For Trading"
        },
        {
            image: "/images/palmoil2.jpg",
            title: "Premium Quality Palm Oil"
        },
        {
            image: "/images/chocolate-2.jpg",
            title: "Gourmet Chocolate Ingredients"
        },
        {
            image: "/images/milkpowder.jpg",
            title: "Excellent Quality Milk Products"
        }
    ];

    return (
        <div>

            <CustomNavbar />

            <FullScreenCarousel
                slides={slides}
                interval={5000}
            />

             <HomeCards />

            <Footer />

        </div>
    );
}

export default HomePage;